// reCAPTCHA Key Validation and Troubleshooting Guide

/*
TROUBLESHOOTING "Invalid key type" ERROR:

1. CHECK KEY TYPES:
   - reCAPTCHA v2 Site Key starts with: 6L...
   - reCAPTCHA v3 Site Key starts with: 6L...
   - Secret keys also start with: 6L...

2. YOUR CURRENT KEYS:
   Site Key: 6Lf91xYsAAAAAIi_rRu3fKL8-TaNhji76ceHIxME
   Secret Key: 6Lf91xYsAAAAAJ7D-x70Bvm98FrLA9sF-RVjoY3I

3. VERIFY DOMAIN CONFIGURATION:
   Go to https://www.google.com/recaptcha/admin
   Check if your domain is properly configured:
   - localhost (for development)
   - your-qa-domain.com (for QA)
   - your-production-domain.com (for production)

4. COMMON FIXES:
   a) Make sure you're using the correct key type (v2 vs v3)
   b) Add all your domains to the reCAPTCHA configuration
   c) Double-check the keys for any typos

5. TEST DOMAINS TO ADD:
   - localhost
   - 127.0.0.1
   - qa-ia.waseel.com
   - stg-ia.waseel.com
   - your-production-domain.com

6. IF KEYS DON'T WORK:
   Create new reCAPTCHA keys at https://www.google.com/recaptcha/admin
   - Select reCAPTCHA v2 ("I'm not a robot" checkbox)
   - Add all your domains (including localhost for development)
   - Copy the new keys and replace in environment files
*/

import { Injectable } from '@angular/core';
import { environment } from '../../assets/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RecaptchaDebugService {
  
  validateConfiguration(): void {
    console.log('🔍 reCAPTCHA Configuration Debug:');
    console.log('Site Key:', environment.recaptcha?.siteKey);
    console.log('Current Domain:', window.location.hostname);
    console.log('Current URL:', window.location.href);
    
    if (!environment.recaptcha?.siteKey) {
      console.error('❌ reCAPTCHA site key not configured!');
      return;
    }
    
    const siteKey = environment.recaptcha.siteKey;
    
    // Basic key format validation
    if (!siteKey.startsWith('6L')) {
      console.error('❌ Invalid site key format. Should start with "6L"');
    } else {
      console.log('✅ Site key format looks correct');
    }
    
    // Check key length (typical Google keys are around 40 characters)
    if (siteKey.length < 30 || siteKey.length > 50) {
      console.warn('⚠️ Site key length seems unusual:', siteKey.length, 'characters');
    } else {
      console.log('✅ Site key length looks normal');
    }
    
    console.log('💡 If you see "Invalid key type" error:');
    console.log('1. Check if your domain is added to reCAPTCHA admin console');
    console.log('2. Verify you\'re using v2 keys (not v3)');
    console.log('3. Make sure localhost is added for development');
  }
  
  getCurrentDomainInfo(): { hostname: string; port: string; protocol: string } {
    return {
      hostname: window.location.hostname,
      port: window.location.port,
      protocol: window.location.protocol
    };
  }
}